import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledGeneralDesktopContainer = styled.div`
  justify-content: space-between;

  ${MediaQueries.mbUp} {
    padding: 0 16px;
  }

  background-color: ${theme.colors.white};
  &[data-view-type='gird'] {
    ${MediaQueries.mbUp} {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-left: -16px;
    }
  }
  ${MediaQueries.mbDown} {
    .gird-view > .container > .section {
      max-width: 295px;
    }
  }
`

export const StyledHeroContainer = styled.div`
  display: flex;
  width: 50%;
  max-width: 500px;
  align-self: stretch;
  justify-content: stretch;

  background-color: ${theme.colors.white};

  justify-self: stretch;

  & > div > div {
    height: 100%;
  }

  .banner {
    min-height: 312px;
  }
`

export const StyledArticleContainer = styled.div`
  background-color: ${theme.colors.white};

  .banner {
    width: 100%;
    min-height: 192px;
  }

  ${MediaQueries.mbUp} {
    padding: 24px 16px 24px 0;
  }

  ${MediaQueries.mbDown} {
    padding: 24px 0;
  }
`

export const StyledSubHeroContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 8px;
  margin-left: -16px;
  background-color: ${theme.colors.white};

  .banner {
    min-height: 150px;
  }

  .content .new .text {
    margin: 6px 0;
  }

  & > :last-child {
    flex: 1;
  }
`

export const StyledArticleDesktopContainer = styled.div`
  ${MediaQueries.mbUp} {
    &[data-columns='4'] {
      width: calc(25% - 16px);
    }
    &[data-columns='3'] {
      width: calc(33% - 16px);
    }
    &[data-columns='2'] {
      width: calc(50% - 16px);
    }
    padding: 16px;
  }

  ${MediaQueries.mbDown} {
    padding: 8px;
  }

  background-color: ${theme.colors.white};
`
export const StyledTitleContainer = styled.div`
  ${MediaQueries.mbUp} {
    padding: 0 16px;
  }
`

export const StyledFeatureSmallArticleContainer = styled.div`
  ${MediaQueries.mbUp} {
    padding: 16px 0;
    & > div[data-type='group1'][data-size='sm'] .banner {
      height: 150px;
      min-width: 200px;
    }
  }

  background-color: ${theme.colors.white};
`
